import { OrderInputModel } from '@ail/orders-api'
import { useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { NavLink } from 'react-router-dom'
import { useGetWorkItemsFormsQuery, usePostWorkItemMutation } from '../../redux/api/ordersApi'
import { captchaSiteKey, emptyGuid } from '../../types/constants'
import { FormBuilder } from './FormBuilder/FormBuilder'
import './RegistrationComponent.scss'
import { Loader } from '../common/Loader/Loader'

export default function RegistrationComponent() {
  const [validate, setValidate] = useState(false)
  const [valid, setValid] = useState(false)
  const [captchaToken, setCaptchaToken] = useState<string>('')
  const [data, setData] = useState({})

  const recaptcha = useRef<ReCAPTCHA>(null)

  const workItemsForms = useGetWorkItemsFormsQuery()
  const [postWorkItem, postWorkItemResult] = usePostWorkItemMutation()

  const registrationForm = workItemsForms.data?.find((f) => f.name === 'ILink registration form')
  const loading = workItemsForms.isFetching || postWorkItemResult.isLoading

  const onCaptchaChange = (token: string | null) => {
    if (token) {
      setCaptchaToken(token)
    } else {
      setCaptchaToken('')
    }
  }

  const handleSubmit = () => {
    if (registrationForm) {
      const order: OrderInputModel = {
        approvalProcessConfigId: emptyGuid,
        formId: registrationForm.id,
        data: data,
      }
      postWorkItem(order)
    }
  }

  return (
    <Loader blocking={loading}>
      <div className="container registration">
        <div className="home">
          <NavLink to="/">
            <img
              alt="InterfleetLink"
              src="/img/interfleetlink_logo.svg"
              width="390"
              height="87"
              className="logo"
              data-fallback="/img/interfleetlink_logo.png"
            />
          </NavLink>
          <form>
            <div className="row">
              {registrationForm && (
                <FormBuilder
                  onUpdate={setData}
                  setValid={setValid}
                  form={registrationForm.formFields}
                  sections={registrationForm.sections}
                  validate={validate}
                />
              )}

              <div className="col-12 col-md-12">
                <div className="box">
                  <div className="validateArea">
                    <ReCAPTCHA onChange={onCaptchaChange} ref={recaptcha} sitekey={captchaSiteKey} />

                    <div className="btnArea">
                      <a
                        className={['btn', !valid || !validate ? '' : 'disabled', validate ? 'hidden' : ''].join(' ')}
                        onClick={() => setValidate(true)}
                      >
                        Validate
                      </a>
                      <a
                        onClick={handleSubmit}
                        className={['btn', validate && valid && captchaToken ? '' : 'disabled'].join(' ')}
                      >
                        Anfrage Senden
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Loader>
  )
}
